import { render, staticRenderFns } from "./JoinType.vue?vue&type=template&id=0c74fee6&scoped=true"
import script from "./JoinType.vue?vue&type=script&lang=js"
export * from "./JoinType.vue?vue&type=script&lang=js"
import style0 from "./JoinType.vue?vue&type=style&index=0&id=0c74fee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74fee6",
  null
  
)

export default component.exports